module.exports = __webpack_public_path__ + "static/media/b12-平安桥.305b6037.png";